import gsap from 'gsap'

export function delay(seconds: number): Promise<void> {
  return new Promise((r) => gsap.delayedCall(seconds, r))
}
